module.exports = "<route-planning-page></route-planning-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/planning.html
// module id = 1842
// module chunks = 0